module.exports = __webpack_public_path__ + "img/chevron-right-icon.54163c88.svg";